import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

const NavMenu = () => {
  const { order_status } = useSelector((state) => state.auth);
  const status = order_status?.value;
  const [totalStatus, setTotalStatus] = useState(0);

  useEffect(() => {
    setTotalStatus(
      status?.reduce((tot, ex) => {
        return tot + ex.count || 0;
      }, 0)
    );
  }, [status]);

  // Get Windows Width
  const [windowSize, setWindowSize] = useState([window.innerWidth]);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowSize]);
  // End Get Windows Width

  // Handle for Header
  const mobile = useMemo(() => windowSize < 768, [windowSize]);
  const menuTextStyleMobile =
    "w-full flex justify-center cursor-pointer bg-gray-400 text-white hover:text-blue-700 py-2 text-sm font-semibold border-b-[1px] border-black";
  const menuTextStyleNormal =
    "w-12/12 md:w-3/12 flex justify-center cursor-pointer hover:text-blue-700 hover:bg-orange-300 rounded-t-[12px] text-sm font-semibold";
  const correctPageMobile = "w-full flex justify-center";
  const correctPageNormal =
    "w-12/12 md:w-full flex justify-center bg-orange-500 rounded-t-[12px] text-white";
  const [menuTextStyle, setMenuTextStyle] = useState(menuTextStyleNormal);
  const [correctPage, setCorrectPage] = useState(correctPageNormal);
  useEffect(() => {
    if (mobile) {
      setMenuTextStyle(menuTextStyleMobile);
      setCorrectPage(correctPageMobile);
    }

    if (!mobile) {
      setMenuTextStyle(menuTextStyleNormal);
      setCorrectPage(correctPageNormal);
    }
  }, [mobile]);

  // Open Menu
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="w-full w-12/12 mx-auto md:px-4 mb-4 md:my-6 flex flex-col md:flex-row md:flex-wrap justify-center items-center shadow-md">
      {!mobile || openMenu ? (
        <>
          {openMenu && mobile && (
            <div
              onClick={() => setOpenMenu(false)}
              className="w-full bg-gray-800 mt-[1px] py-[2px] flex justify-center items-center cursor-pointer"
            >
              <h1 className="text-2xl flex justify-center items-center gap-2 text-orange-500">
                <span className="text-lg font-bold text-white"> 近い</span>
                <FaAngleUp />
              </h1>
            </div>
          )}
          <NavLink
            to="order-status"
            onClick={() => {
              setOpenMenu(false);
            }}
            className={menuTextStyle + " relative"}
          >
            {({ isActive }) => (
              <div className={isActive ? correctPage : undefined}>
                受注状況 ({totalStatus})
              </div>
              // <p className={isActive ? correctPage : undefined}>Tasks</p>
            )}
          </NavLink>
          <NavLink
            to="orders"
            onClick={() => setOpenMenu(false)}
            className={menuTextStyle}
          >
            {({ isActive }) => (
              <p className={isActive ? correctPage : undefined}>注文一覧</p>
            )}
          </NavLink>
          <NavLink
            to="setting"
            onClick={() => setOpenMenu(false)}
            className={menuTextStyle}
          >
            {({ isActive }) => (
              <p className={isActive ? correctPage : undefined}>設定</p>
            )}
          </NavLink>
        </>
      ) : (
        <div
          onClick={() => setOpenMenu(true)}
          className="w-full bg-gray-800 mt-[1px] py-[2px] flex justify-center items-center cursor-pointer"
        >
          <h1 className="text-2xl flex justify-center items-center gap-2 text-orange-500">
            <span className="text-lg font-bold text-white"> メニュー</span>
            <FaAngleDown />
          </h1>
        </div>
      )}

      {/*  */}
    </div>
  );
};

export default NavMenu;
